import { render, staticRenderFns } from "./Review.vue.html?vue&type=template&id=ea2540ba&scoped=true&"
import script from "./Review.component.js?vue&type=script&lang=vueJs&"
export * from "./Review.component.js?vue&type=script&lang=vueJs&"
import style0 from "./Review.scoped.scss?vue&type=style&index=0&id=ea2540ba&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea2540ba",
  null
  
)

export default component.exports